import { type RuleType } from '../IRule.ts';
import { type IRulesConfig } from './getAllRuleTypes.ts';

/**
 * Ritorna la configurazione di una regola di un certo tipo
 * da un widget, tipizzata con il tipo specificato
 */
export function extractRule<T>(
  rules: IRulesConfig | null | undefined,
  type: RuleType,
): T | null | undefined {
  return rules?.[type] as T;
}
